import { StaffColumnKey } from '../enums/staff-table-columns.enum';
import { BASE_CELL_CLASS, BASE_HEADER_CLASS } from './table-style.constants';

export interface StaffTableColumn {
  key: StaffColumnKey;
  label: string;
  headerClass: string;
  cellClass?: string;
  sortable?: boolean;
  isFullName?: boolean;
}

export const STAFF_TABLE_COLUMNS_CONFIG: StaffTableColumn[] = [
  {
    key: StaffColumnKey.StaffFirstName,
    label: 'staff.table.headerLabels.name',
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--name`,
    isFullName: true,
    cellClass: BASE_CELL_CLASS,
    sortable: true,
  },
  {
    key: StaffColumnKey.StaffEmail,
    label: 'staff.table.headerLabels.email',
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--email`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: StaffColumnKey.StaffRole,
    label: 'staff.table.headerLabels.role',
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--phone`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: StaffColumnKey.Status,
    label: 'staff.table.headerLabels.status',
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--status`,
    cellClass: BASE_CELL_CLASS,
  },
  {
    key: StaffColumnKey.Actions,
    label: 'staff.table.headerLabels.actions',
    headerClass: `${BASE_HEADER_CLASS} ${BASE_HEADER_CLASS}--actions`,
  },
];

export const FAKE_STAFF_QUANTITY = 5;
